export enum CreatedBy {
    ADMIN = 'admin',
    APPLICATION = 'application',
}
